import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate, Navigate } from "react-router-dom";
import "@/App.css";
import { api } from "@/lib/api";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import VerifyTessera from "@/pages/VerifyTessera";

function ProtectedRoute({ children }) {
  const [state, setState] = useState({ loading: true, user: null });
  const navigate = useNavigate();

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (window.location.hash?.includes("session_id=")) {
      setState({ loading: false, user: null });
      return;
    }
    api.get("/auth/me").then((r) => {
      setState({ loading: false, user: r.data });
    }).catch(() => {
      setState({ loading: false, user: null });
      navigate("/login");
    });
  }, [navigate]);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-secondary font-display text-2xl">Caricamento…</div>
      </div>
    );
  }
  if (!state.user) return <Navigate to="/login" replace />;
  return children({ user: state.user, refetch: () => api.get("/auth/me").then(r => setState({ loading: false, user: r.data })) });
}

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/verify/:number" element={<VerifyTessera />} />
      <Route path="/" element={
        <ProtectedRoute>
          {({ user, refetch }) => <Dashboard user={user} refetch={refetch} />}
        </ProtectedRoute>
      } />
      <Route path="/dashboard" element={
        <ProtectedRoute>
          {({ user, refetch }) => <Dashboard user={user} refetch={refetch} />}
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
